import { SVGProps } from 'react';

const Eclipse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m10 10c0-5.523-4.477-10-10-10m10 10A7.071 7.071 0 1 1 12 2"
    />
  </svg>
);
export default Eclipse;
